<template>
  <div>
    <br/>
    <br/>
    <v-layout row>
      <v-spacer/>
      <v-flex>
        <h1 class="text-center">DK's Aussprache</h1>
      </v-flex>
      <v-spacer/>
    </v-layout>
    <br/>
    <br/>
    <v-layout row>
      <v-spacer/>
      <v-text-field v-model="text"/>
      <v-spacer/>
    </v-layout>
    <br/>
    <br/>
    <v-layout row>
      <v-spacer/>
      <v-flex v-if="text">
        <h2 class="text-center">DK würde sagen:</h2><br/>
        <p class="text-center">{{formatedText}}</p>
      </v-flex>
      <v-spacer/>
    </v-layout>
    <br/>
    <br/>
    <v-layout row>
      <v-spacer/>
      <v-switch
        v-model="dark"
        :label="dark ? 'Light Mode' : 'Dark Mode'"
        @change="$vuetify.theme.dark = !$vuetify.theme.dark"
      ></v-switch>
      <v-spacer/>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: '',
      schmatches: [
        'Jens',
        'Lukas',
        'Memphis',
      ],
      dark: false,
    };
  },
  computed: {
    formatedText() {
      if (this.text === 'Good Bye') {
        return 'Guten Einkauf';
      }
      let str = '';
      const textElements = this.text.split(' ');
      textElements.forEach((elem) => {
        let copyElem = elem;
        if (this.checkWord(elem)) {
          copyElem = `Schm${copyElem.substr(1)}`;
        } else if (elem === 'Mittag') {
          copyElem = 'Middag';
        }
        str += `${copyElem} `;
      });
      return str;
    },
  },
  methods: {
    checkWord(word) {
      let check = false;
      this.schmatches.forEach((match) => {
        if (word.substr(0, match.length) === match) check = true;
      });
      return check;
    },
  },
  created() {
    const date = new Date();
    const hours = date.getHours();

    if (hours < 7 || hours > 19) {
      this.dark = true;
      this.$vuetify.theme.dark = true;
    }
  },
};
</script>
